let navToggleBtn = document.querySelector('.navbar-toggle');
let navMenu = document.querySelector('.mobile-nav');
let dropdownNavLinks = Array.from(document.querySelectorAll('.nav-menu__item.has-children'));

export const initMobileNavigation = () => {
	function resetAllNavItems() {
		dropdownNavLinks.forEach((dropdown) => {
			dropdown.classList.remove('open');
		});
	}

	navToggleBtn?.addEventListener('click', () => {
		resetAllNavItems();
		navMenu.classList.toggle('nav-is-open');
		navToggleBtn.classList.toggle('open');
		document.querySelector('body').classList.toggle('no-scroll');
	});

	dropdownNavLinks.forEach((dropdown) => {
		dropdown.addEventListener('click', (event) => {
			event.target.classList.toggle('open');
		});
	});

	window.addEventListener('resize', () => {
		if (window.innerWidth > 990) {
			dropdownNavLinks.forEach((dropdown) => {
				dropdown.classList.remove('open');
			});
			navMenu.classList.remove('nav-is-open');
			navToggleBtn.classList.remove('open');
		}
	});
};
